export default __webpack_public_path__ + "78804322a09d2c8ea63c5f798c42a3f1.svg";